import { UseMediaQueryOptions, useMediaQuery } from '@mui/material';

import { MEDIA_QUERIES } from '@arrived/common';

export function useIsMobile(options?: UseMediaQueryOptions) {
  return useMediaQuery(MEDIA_QUERIES.isMobile, options);
}
